import type {TDevice} from "services-comun/modules/net/device";
import type {TSite} from "services-comun-meteored/modules/portal/tiempo";
import {immute} from "services-comun/modules/utiles/object";

export interface IConf {
    device: TDevice;
    site: TSite;
    cfg: {
        news: {
            enabled: boolean;
            ram: boolean;
        };
    };
    dd: {
        version: string;
    };
}

declare var _mr_: IConf;

export default immute(_mr_);
